import MaterialTable from 'material-table';
import React from 'reactn';
import { useCallHistoryListComponentHook } from './useCallHistoryListComponentHook';
import styles from './call-history.component.style';
import { withStyles } from '@material-ui/styles';
import MuiAlert from '@material-ui/lab/Alert';
import { Box, Button, Snackbar } from '@material-ui/core';
import CallHistoryDetailsDrawer from '../call-history-details-v2/call-history-details-v2';
import CallHistoryDetailModal from '../call-history-details-modal/call-history-details-modal';
import { UnleashService } from '../../../../v2/services';
import { CustomIcons, icons } from '../../../../v2/shared/components/custom-icons';
import useUnleashHook from '../../../../v2/core/unleash/useUnleashHook';
import { DataGridWithHeaders } from '@orijinworks/frontend-commons';

export const CallHistoryList = (props) => {
  const {
    isLoading,
    callHistoryData,
    totalCount,
    tableRef,
    tableColumns,
    columns,
    defaultPageSize,
    openSnackbar,
    snackbarMessage,
    snackbarAutoHideDuration,
    isSuccessSnackbar,
    isDetailModalOpen,
    lastRefreshed,
    handleCloseHistoryDetailsModal,
    callDetails,
    transcriptData,
    transcriptSummary,
    detectedKeywords,
    recordingUrl,
    handleCloseSnackbar,
    getCallHistoryListData,
    isPrivileged,
    formatLastRefreshedTime,
    onPageChange,
    onPageSizeChange,
    onSortChange,
    onFilterChange,
    onRefreshHandler,
  } = useCallHistoryListComponentHook(props, true);

  const tableColumnsRef = React.useRef(tableColumns);
  const isFlagEnabled = useUnleashHook(UnleashService.FLAGS.CALL_HISTORY_LIVE_CALLS_DESIGN_V2).isFlagEnabled();
  const isV2CallHistoryFlagEnabled = useUnleashHook(UnleashService.FLAGS.V2_CALL_HISTORY).isFlagEnabled();

  const getV1DataGrid = () => (
    <>
      <Box
        id="call-history-export-button"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: '16px 0px',
          justifyContent: 'flex-end',
          gap: '16px',
          height: '40px',
          width: '100%',
        }}
      >
        <Button
          id="export-button"
          variant='contained'
          color="primary"
          onClick={() => props.setShouldExportCallHistory(true)}
          startIcon={<CustomIcons icon={icons.FileDownload} />}
        >
          Export Call History
        </Button>
      </Box>

      {props.locationId ? (
        <MaterialTable
          tableRef={tableRef}
          columns={tableColumnsRef.current}
          data={getCallHistoryListData}
          options={{
            filtering: true,
            pageSize: defaultPageSize,
            thirdSortClick: false,
            search: false,
            toolbar: false,
          }}
        />
      ) : null}
    </>
  );
  const getV2DataGrid = () => (
    <>
      <Box sx={{
        height: '100%',
        marginTop: '-24px',
        '& > div': {
          backgroundColor: 'white'
        },
        '& .main-table': {
          minWidth: 1755
        }
      }}>
        <DataGridWithHeaders
          title="Call History"
          subtitle={formatLastRefreshedTime(lastRefreshed)}
          dataGridProps={{
            columns: columns,
            data: callHistoryData,
            pageSize: defaultPageSize,
            pageSizeOptions: [5, 10, 25, 50],
            paginationMode: 'server',
            isLoading,
            isAllSelected: false,
            serverSidePaginationProps: {
              onPageChange,
              onPageSizeChange,
              onSortChange,
              onFilterChange,
              totalRecordsCount: totalCount
            },
            primaryButtonProps: {
              text: 'EXPORT CALL HISTORY',
              variant: 'contained',
              startIcon: <CustomIcons icon={icons.FileDownload} />,
              onClick: () => props.setShouldExportCallHistory(true),
              sx: {
                minWidth: 250
              }
            },
            onRefreshHandler: onRefreshHandler,
            hasActionColumn: false,
            tdStyles: {
              LearnerCell: {
                width: 350,
              },
              contactName: {
                width: 178
              },
              phoneNumber: {
                width: 182
              },
              relationship: {
                width: 163
              },
              status: {
                width: 186
              },
              callEndedTime: {
                width: 156,
              },
              voiceCallInsights: {
                width: 180
              },

            }
          }}
        />
      </Box>
    </>
  );

  return (
    <>
      {isFlagEnabled ? (
        <CallHistoryDetailsDrawer
          isDetailModalOpen={isDetailModalOpen}
          handleCloseHistoryDetailsModal={handleCloseHistoryDetailsModal}
          {...callDetails}
          recordingUrl={recordingUrl}
          isPrivileged={isPrivileged}
          transcriptData={transcriptData}
          transcriptSummary={transcriptSummary}
          detectedKeywords={detectedKeywords}
        />
      ) : (
        <CallHistoryDetailModal
          isDetailModalOpen={isDetailModalOpen}
          handleCloseHistoryDetailsModal={handleCloseHistoryDetailsModal}
          {...callDetails}
          recordingUrl={recordingUrl}
          isPrivileged={isPrivileged}
          transcriptData={transcriptData}
          transcriptSummary={transcriptSummary}
        />
      )}

      {/* BEGIN: V2 CALL HISTORY */}
      {isV2CallHistoryFlagEnabled && getV2DataGrid()}
      {/* END: V2 CALL HISTORY */}


      {/* BEGIN: V1 CALL HISTORY */}
      {!isV2CallHistoryFlagEnabled && getV1DataGrid()}
      {/* END: V1 CALL HISTORY */}

      <Snackbar
        id={'call-history-snackbar'}
        open={openSnackbar}
        autoHideDuration={snackbarAutoHideDuration}
        onClose={handleCloseSnackbar}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackbar}
          severity={isSuccessSnackbar ? 'success' : 'error'}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default withStyles(styles)(CallHistoryList);
